var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommentsOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Stickersheets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Styleguide-/-Logo-/-Colors-/-Typography-/-Buttons-/-Icons-/-Inputs-/-Loaders-/-Checkboxes-/-Tabs-/-Pagination-/-Lables-",
    transform: "translate(-496.000000, -2456.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-comments-ea57-on",
    transform: "translate(496.000000, 2456.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(4.500000, 4.500000)",
    fill: "#283049",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.25,3 L12.75,3 L12.75,9.75 L3,9.75 L3,11.25 C3,11.6625 3.3375,12 3.75,12 L12,12 L15,15 L15,3.75 C15,3.3375 14.6625,3 14.25,3 Z M11.25,7.5 L11.25,0.75 C11.25,0.3375 10.9125,0 10.5,0 L0.75,0 C0.3375,0 0,0.3375 0,0.75 L0,11.25 L3,8.25 L10.5,8.25 C10.9125,8.25 11.25,7.9125 11.25,7.5 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentsOff);
export default __webpack_public_path__ + "static/media/comments-off.7a58091f.svg";
export { ForwardRef as ReactComponent };